import React from 'react';
// eslint-disable-next-line import/no-unresolved
import { useRegisterSW } from 'virtual:pwa-register/react';
import SwContext from '.';

const intervalMS = 5 * 60 * 1000;

export default function SwContextProvider(props: {children: React.ReactNode}) {
  const { children } = props;

  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegistered(r) { if (r) { setInterval(() => { r.update(); }, intervalMS); } },
    onRegisterError(error) { console.error('SW registration error', error); },
  });

  const value = React.useMemo(() => ({
    needRefresh,
    refresh() {
      updateServiceWorker(true).then(() => {
        setNeedRefresh(false);
        window.location.reload();
      });
    },
  }), [needRefresh, updateServiceWorker]);

  return (
    <SwContext.Provider value={value}>
      {children}
    </SwContext.Provider>
  );
}
